import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Back-button guard (runs ONCE, before React mounts) ──
// If the very first page the user loads is a guest auth page (register/login),
// insert a real HOME entry BEHIND it in the browser's session history. That way
// the first Back press — desktop Back OR a phone's hardware/gesture back — is a
// genuine navigation to Home instead of exiting the whole site (ad / social /
// direct landings). The entries are written in React Router 7's exact
// history-state shape { usr, key, idx } so RRv7 tracks the Back as a real POP to
// Home (idx 0) from the auth page (idx 1) — not as a history-boundary exit.
try {
  const _key = () => Math.random().toString(36).substring(2, 10);
  const _p = window.location.pathname;
  const _guest = _p === "/register" || _p === "/login" || _p === "/affiliate/register";
  const _st = window.history.state;
  const _alreadySeeded = _st && (_st.__mx88seed || typeof _st.idx === "number");
  if (_guest && !_alreadySeeded) {
    const _q = window.location.search || "";
    window.history.replaceState({ usr: null, key: _key(), idx: 0, __mx88seed: 1 }, "", "/");
    window.history.pushState({ usr: null, key: _key(), idx: 1, __mx88seed: 1 }, "", _p + _q);
  }
} catch (e) {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
